import { User } from "@models/index";
import {StrainReportType} from "@app/strain/common/models/enum/strain-report-type.enum";

export class StrainReportModel {

    public id: number;
    public name: string;
    public initial: boolean;
    public createdAt: string;
    public createdBy: User;
    public availableTypes:  StrainReportType[];

    constructor(report: any = {}) {
        this.id = report.id;
        this.name = report.name;
        this.initial = report.initial;
        this.createdAt = report.createdAt;
        this.createdBy = report.createdBy ? new User(report.createdBy) : null;
        this.availableTypes = report.availableTypes;
    }
}
